

























































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { consoleInfo } from 'vuetify/src/util/console';
@Component({
  $_veeValidate: { validator: 'new' },
})
export default class Servicios extends Vue {
  private panel:any = -1;
  private dialog = false;
  private active = true;
  private checkbox = [];
  private servicios: any = [];
  private mascotas = this.$store.getters.mascotasCita;
  private selected: any = [];
  private notasPet: any = Array(this.mascotas.length);
  private radios: any = Array(this.mascotas.length);
  private visibles: any = Array(this.mascotas.length);
  private activeBtn = '';
  private valid = true;
  private errorServicios = false;
  private arrayDesc: any = {mascota: '', servicio: '', notas: ''};
  private arrayIDs: any = {mascota: '', servicio: '', notas: ''};
  private serviciosSelected = this.$store.getters.serviciosText;
  private expand = true; //Variable que mantiene abierto el v-group
  private expandFlag = { 
    flag_uno: false,
    flag_dos: false,
    flag_tres: false,
    flag_cuatro: false,
  }
  /*SnackBar*/
  private snackbar = false;
  private text = '';
  private type = '';
  private timeout = 2000;
  private errores = false;
  private cambios = false;
  /*Dialog*/
  private dialogInfo = false;
  private imgDialog = '';
  private tituloServicio = '';
  private descServicio = '';
  private dialogServicios = false;
  private paso = 3;
  /* TimeOut */
  private timeOutInicial: any = this.$store.getters.timeOut;
  private timeOut: any = 0;
  private intervalo: any;
  private dialogTime = false;
  /* Promociones */
  private promociones2: any = [];
  private nombrePromo = '';
  private fechaIPromo = '';
  private fechaFPromo = '';
  private nombreMascotaSel = '';
  private dialogPromo = false;
  private imagenMascota = '';
  private idPetco = this.$store.getters.user;



  private dialogConfirm = false;

  // Ir atrás 
  private async goBack() {
    history.back();
  }

  private unlock() {
  if (this.$store.getters.user !== null && this.$store.getters.user !== undefined && this.$store.getters.user !== '') {
    const idCitas: any = [];
    let data = { idCliente: this.$store.getters.user, idCita: [] };
    for (const id of this.$store.getters.idCitaBloqueo) {
      idCitas.push(id.ID_CITA);
    }
    if (idCitas.length > 0) { // Hay citas
      data.idCita = idCitas;
      const promise = this.$store.dispatch('desbloquearHorarioCita', data);
      promise.then(async (val) => {
        if (val === 200) {
          return true;
        }
      });
    } else {
      return true;
    }
  } else {
    return false;
  }
}

// Ir a Home
private async home() {
  this.unlock();
  if (await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter)) {
    this.$store.dispatch('resetAll');
    this.$store.commit('setUser', undefined);
    this.$router.push('/callCenter/clubpetco');
  } else {
    this.$store.dispatch('resetAll');
    this.$router.push('/tiendas');
  }
}


  private isIn(element: any, array: any){
    for (const x of array) {
      if (element === x.RAZA) {
        return true;
      }
    }
    return false;
  }

  // Verifica si se encuentra un material y una raza en el arreglo de promociones 
  private isInMascServ(element: any, element2: any, array: any){
    for (const x of array) {
      if (element === x.MATERIAL && element2 === x.RAZA) {
        return true;
      }
    }
    return false;
  }

  private infoPromo(material: any, raza: any, i: any) {
    // Filtramos promociones por raza
    for (const x of this.promociones2) {
      if (raza === x.RAZA && material === x.MATERIAL) {
        this.nombrePromo = x.PROMOCION;
        this.fechaIPromo = x.FEC_INI;
        this.fechaFPromo = x.FEC_INI;
        break;
      }
    }
    this.nombreMascotaSel = this.mascotas[i].NOMBRE;
    this.dialogPromo = true;
  }

  // Redirige a tiendas una vez que se acabó el tiempo
  private async goTiendas(){
    this.$store.dispatch('resetAll');
    this.$router.push(await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter) ? '/callCenter/tiendas' : '/tiendas');
  }

  private isDefined(param: any) {
      return param !== null && param !== undefined && param !== '';
  }
  // Cuenta regresiva
  private cuentaRegresiva(deadline: any) {
    let now: any = new Date();
    let t: any = new Date(deadline);
    let tiempoRestante = (t - now + 1000) / 1000;
    let segRestantes = ('0' + Math.floor(tiempoRestante % 60)).slice(-2);
    let minRestantes = ('0' + Math.floor(tiempoRestante / 60 % 60)).slice(-2);
    return tiempoRestante * 1000;
  }

 @Watch('radios')
  private onMonthChanged(radios: any) {
    //Mostramos los servicios adicionales de acuerdo a la mascota seleccionada
    for (const r in radios) {
      this.visibles[r] = '';
    }
  }

  @Watch('servicios')
  private onServiciosLoaded(serv: any){
    if (serv.length === 0) {
      this.dialogServicios = true;
    } else {
      this.dialogServicios = false;
    }
  }

  //Click en información de cada servicio
  private showInfo(i: any, j:any) {
    this.imgDialog = this.servicios[i][j].URL_IMAGE;
    this.tituloServicio = this.servicios[i][j].TITULO;
    this.descServicio = this.servicios[i][j].DESCRIP;
    this.dialogInfo = true;
  }

  private formatDate(fecha: any) {
    const anio = fecha.substring(0, 4);
    const mes = fecha.substring(4, 6);
    const dia = fecha.substring(6, 8);
    let mesString = '';
    if (mes === '01') {
      mesString = 'Enero';
    } else if (mes === '02') {
      mesString = 'Febrero';
    } else if (mes === '03') {
      mesString = 'Marzo';
    } else if (mes === '04') {
      mesString = 'Abril';
    } else if (mes === '05') {
      mesString = 'Mayo';
    } else if (mes === '06') {
      mesString = 'Junio';
    } else if (mes === '07') {
      mesString = 'Julio';
    } else if (mes === '08') {
      mesString = 'Agosto';
   } else if (mes === '09') {
      mesString = 'Septiembre';
    } else if (mes === '10') {
      mesString = 'Octubre';
    } else if (mes === '11') {
      mesString = 'Noviembre';
    } else if (mes === '12') {
      mesString = 'Diciembre';
    }
    return dia  + ' de ' + mesString  + ' de ' + anio;
  }

  private async created() {
    // Llenamos como no visibles los servicios adicionales de acuerdo al número de mascotas
    for (let v = 0; v < this.visibles.length; v++) {
      this.visibles[v] = 'd-none';
    }
    // Traemos los servicios de las mascotas
    for (const masc of this.mascotas) {
      await this.$store.dispatch('getServiciosRazas', masc.RAZA)
      .then((val: any) => {
        this.errorServicios = false;
        this.servicios.push(val);
      })
      .catch((error: any) => {
        this.errorServicios = true;
      });

      // Traemos las promociones
      this.$store.dispatch('getPromociones', masc.RAZA)
      .then((resultado: any) => {
        if (resultado.replyCode === 200) {
          for (const m of resultado.data) {
            this.promociones2.push(m);
          }
        }
      });
    }

    if (this.$store.getters.radios.length > 0) {
      this.radios = this.$store.getters.radios;
    }
    if (this.$store.getters.checkboxes.length > 0) {
      this.selected = this.$store.getters.checkboxes;
    }

    // Llenamos los servicios traidos desde el store
    let a = 0;
    for (const s of this.serviciosSelected) {
      this.notasPet[a] = s.notas === undefined ? 'Sin notas especiales' : s.notas;
      a++;
    }

    // Llamamos a la cuenta regresiva
    if (this.timeOutInicial > 0) { // Edición
      this.timeOutInicial = Date.now() + this.timeOutInicial -3000;
      this.intervalo = setInterval( () => {
        this.timeOut =  this.cuentaRegresiva(this.timeOutInicial);
        if (this.timeOut <= 1) { // se acabó el tiempo, se resetea todo
          clearInterval(this.intervalo);
          this.dialogTime = true;
        }
      }, 1000);
    }
  }
  
  private validateForm() {
    this.valid = false;
    this.$validator.validate()
    .then(async(result) => {
      if (result && !this.radios.includes(null) && !this.radios.includes(undefined)) {// Formulario correcto
        // Juntamos ambas selecciones (obligatorios y adicionales)
        let mixed = this.radios.concat(this.selected);
        let mixedState: any = {};
        mixed.forEach((x: any) => {
          let sp = x.split(",");
          const idMascota = sp[4];
          if (!mixedState[idMascota])
            mixedState[`${idMascota}`] = { servicio: [] };
          mixedState[`${idMascota}`].servicio.push({
            servicio: sp[1],
            tipo_serv: sp[5]
          });
        });

        // Llenamos el arreglo con razas y servicios a enviar
        let mixedO = mixed.map((item: any) => {
          let sp = item.split(",");
          let array = {id_mascota: '', raza: '', servicio: '', tipoServicio: ''};
          array.raza = sp[0];
          array.servicio = sp[1];
          array.id_mascota = sp[4];
          array.tipoServicio = sp[5];
          return array;
        });
        this.$store.dispatch('setTipoServicios', mixedState);
        //Llenamos el arreglo informativo con los servicios por mascota (SOLO PARA MOSTRAR LOS SERVICIOS POR MASCOTA)
        this.arrayDesc = mixed.map((item: any) => {
          let sp = item.split(",");
          let array = {mascota: '', servicio: '', tipoServicio: ''};
          array.mascota = sp[3];
          array.servicio = sp[2];
          array.tipoServicio = sp[5]
          return array;
        });

        this.arrayIDs = mixed.map((item: any) => {
          let sp = item.split(",");
          let array = {mascota: '', servicio: '', tipoServicio: ''};
          array.mascota = sp[4];
          array.servicio = sp[1];
          array.tipoServicio = sp[5]
          return array;
        });

        //Agrupamos todos los servicios por id de mascota
        let output:any = [];
        mixedO.forEach(function(item: any) {
          let existing = output.filter(function(v: any, i: any) {
            return v.id_mascota == item.id_mascota;
          });
          if (existing.length) {
            let existingIndex = output.indexOf(existing[0]);
            output[existingIndex].servicio = output[existingIndex].servicio.concat(item.servicio);
          } else {
            if (typeof item.servicio == 'string') {
              item.servicio = [item.servicio];
            }
            output.push(item);
          }
        });

        //Agrupamos los servicios por mascota (INFORMATIVO)
        let salida:any = [];
        this.arrayDesc.forEach(function(item: any) {
          let existing = salida.filter(function(v: any, i: any) {
            return v.mascota == item.mascota;
          });
          if (existing.length) {
            let existingIndex = salida.indexOf(existing[0]);
            salida[existingIndex].servicio = salida[existingIndex].servicio.concat(item.servicio);
          } else {
            if (typeof item.servicio == 'string') {
              item.servicio = [item.servicio];
            }
            salida.push(item);
          }
        });

        // Agrupar por mascota con servicios (IDs)
        let outputID: any = [];
        this.arrayIDs.forEach(function(item: any) {
          let existing = outputID.filter(function(v: any, i: any) {
            return v.mascota == item.mascota;
          });
          if (existing.length) {
            let existingIndex = outputID.indexOf(existing[0]);
            outputID[existingIndex].servicio = outputID[existingIndex].servicio.concat(item.servicio);
          } else {
            if (typeof item.servicio == 'string') {
              item.servicio = [item.servicio];
            }
            outputID.push(item);
          }
        });

        this.arrayDesc = salida;
        for (let x = 0; x < this.notasPet.length; x++) {
          this.arrayDesc[x].notas = this.notasPet[x] === undefined ? 'Sin notas especiales' : this.notasPet[x];
          outputID[x].notas = this.notasPet[x] === undefined ? 'Sin notas especiales' : this.notasPet[x];
        }

        
        // Obtenemos el tiempo mayor de todos los servicios
        let valorMayor = 0;
        // Ya que el arreglo contiene id_mascota, raza y servicios es necesario dejarlo solo con raza y servicios
        let outputFinal: any = [];
        for (let x of output) {
          outputFinal.push({raza: x.raza, servicio: x.servicio});
        }
        let output2 = {"servicios": outputFinal};
        await this.$store.dispatch('getTiempoServicios', output2)
        .then((value) => {
          if (value.replyCode == 200) { // Éxito
            valorMayor = parseInt(value.data.TOTAL);
          }
        })
        .catch((error) => {
          this.errores = true;
        });

        let serviciosSelected: any = []; //Lista de servicios para todas las mascotas
        serviciosSelected = outputID; //Unimos todos los servicios

        // for (const x of output) {
        //   await this.$store.dispatch('getTiempoRazas', x)
        //   .then((value) => {
        //     let total = value.TOTAL.trim();
        //     if (parseInt(total) > valorMayor) {
        //       valorMayor = total;
        //     }
        //   })
        //   .catch((error) => {
        //     this.errores = true;
        //   });
        // }

        // Guardamos el estado de la bandera para almacenar el flujo del programa
        let bandera = this.$store.getters.bandera;
        this.$store.dispatch('setTiempoTotal', valorMayor);
        if (bandera !== 9 && bandera !== 10) { //Flujo normal
          this.$store.dispatch('updateBandera', 4);
          //Guardamos los servicios (id's y texto)
          this.$store.dispatch('setearRadios', this.radios);
          this.$store.dispatch('setearChecks', this.selected);
          this.$store.dispatch('saveServices', serviciosSelected);
          this.$store.dispatch('saveServicesText', this.arrayDesc);
          this.$router.push(await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter) ? '/callCenter/calendario' : '/calendario');
        } else { //Cambio de mascotas o de servicios
          clearInterval(this.intervalo); // Limpiamos timeout
          // Buscar si hubo cambios convirtiendo los arreglos a texto y comparándolos
          if (JSON.stringify(serviciosSelected) === JSON.stringify(this.$store.getters.servicios)) {
            this.$store.commit('setTimeOut', this.timeOut);
            this.$store.dispatch('saveServicesText', this.arrayDesc);
            this.$router.push(await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter) ? '/callCenter/resumenCita' : '/resumenCita'); // ruta a seguir sin cambios
          }
          else {
            // Actualizar valores en state
            this.$store.commit('setTimeOut', 0);
            this.$store.dispatch('setearRadios', this.radios);
            this.$store.dispatch('setearChecks', this.selected);
            this.$store.dispatch('saveServices', serviciosSelected);
            this.$store.dispatch('saveServicesText', this.arrayDesc);
            const idCitas: any = [];
            let data = { idCliente: this.$store.getters.user, idCita: [] };
            for (const id of this.$store.getters.idCitaBloqueo) {
              idCitas.push(id.ID_CITA);
            }
            data.idCita = idCitas;
            const promise = this.$store.dispatch('desbloquearHorarioCita', data);
            promise.then(async (val) => {
              if (val === 200) {
                //Bandera = 10
                this.$store.commit('setIdBloqueo', []);
                this.$router.push(await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter) ? '/callCenter/calendario' : '/calendario'); // Ruta a seguir luego de actualizar
              } else {
                this.$store.commit('setIdBloqueo', []);
                this.$router.push(await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter) ? '/callCenter/calendario' : '/calendario'); // Ruta a seguir luego de actualizar
              }
            })
            .catch((error) => {
              console.log(error);
            });
          }
        }
      } else {
        this.snackbar = true;
        this.type = "error";
        this.text = 'Debes seleccionar al menos un servicio primario.';
        this.valid = false;
      }
    });
  }

}
